export default __webpack_public_path__ + "static/media/OmnicomLogo.898b55cb.png";